import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Select, Option } from 'barnyard/components';
import { getProductLines } from '~/app/corporate/core/selectors';

const ProductLinesSelect = ({
  productLines, value, onChange, mode, ...other
}) => (
  <Select
    mode='multiple'
    optionFilterProp='name'
    useNative={false}
    value={value}
    onChange={onChange}
    {...other}
  >
    {_.map(productLines, p => (
      <Option name={p.name} value={p.id} key={p.id}>{p.name}</Option>
    ))}
  </Select>
);

const mapStateToProps = state => ({
  productLines: getProductLines(state)
});

ProductLinesSelect.propTypes = {
  productLines: PropTypes.array,
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  mode: PropTypes.string
};

export default connect(mapStateToProps)(ProductLinesSelect);
